

















































import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus, LadingCodePrintStatus, LadingCodeStatus} from "@/enums/status";
import {FreightServiceType} from "@/enums/type";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {FreightServiceStore} from "@/modules/freightservices/store";
import debounce from "lodash/debounce";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {LadingCodeParams} from "../../../params";
import {LadingCodeStore} from "../../../store";
import CustomerSelector from "../../../../../shared/components/CustomerSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";

@Component({
  name: "LadingCodeSearch",
  components: {MillisecondDatePicker, CustomerSelector, EnumSelector}
})
export default class extends Vue {
  LadingCodeStatus = LadingCodeStatus;
  LadingCodePrintStatus = LadingCodePrintStatus;
  form = new LadingCodeParams();

  @Watch('form', {immediate: false, deep: true})
  onValuesChange(val: any) {
    this.handleChange(val);
  }

  handleChange = debounce(function (val) {
    LadingCodeStore.updateLadingCodeParams(val);
    LadingCodeStore.listLadingCodes({...val, page: 1})
  }, 500);
}
